// extracted by mini-css-extract-plugin
export var copyableField = "_ic-4";
export var customerBadge = "_ic-0";
export var customerInfoTitle = "_ic-2";
export var details = "_ic-1";
export var dropdownContainer = "_ic-5";
export var dropdownImage = "_ic-6";
export var editAssigneeForm = "_ic-a";
export var editButton = "_ic-3";
export var email = "_ic-7";
export var hidden = "_ic-d";
export var input = "_ic-8";
export var saveButton = "_ic-b";
export var shopifyIcon = "_ic-c";
export var suggestionBadge = "_ic-e";
export var suggestionText = "_ic-f";
export var username = "_ic-9";